<div (click)="clickPlay()">
    <div *ngIf="svgmap" app-svg-canvas [svgmap]="svgmap"></div>
</div>